module.exports = ["SmartContractWallet"]